import { useEffect, useMemo, useRef, useState } from "react";
import { useEmblaCarousel } from "embla-carousel/react";

interface IParams {
    elementsToShow: number;
    slidesCount: number;
}

export const useUsageCarousel = (props: IParams) => {
    const { elementsToShow, slidesCount } = props;

    const initialisationProps = useMemo(() => ({ loop: false, slidesToScroll: elementsToShow }), [elementsToShow]);
    const prevNumberOfElements = useRef(slidesCount);

    const [emblaRef, emblaApi] = useEmblaCarousel(initialisationProps);
    const [isPrevButtonEnabled, setIsPrevButtonEnabled] = useState(false);
    const [isNextButtonEnabled, setIsNextButtonEnabled] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [scrollSnaps, setScrollSnaps] = useState<number[]>([]);

    const scrollPrev = () => emblaApi?.scrollPrev();
    const scrollNext = () => emblaApi?.scrollNext();
    const scrollTo = (index: number) => emblaApi?.scrollTo(index);

    useEffect(() => {
        if (prevNumberOfElements.current !== slidesCount) {
            prevNumberOfElements.current = slidesCount;
            emblaApi?.reInit(initialisationProps);
        }
    }, [emblaApi?.reInit, emblaApi, slidesCount, initialisationProps]);

    useEffect(() => {
        if (emblaApi) {
            const onSelect = () => {
                setSelectedIndex(emblaApi.selectedScrollSnap());
                setIsPrevButtonEnabled(emblaApi.canScrollPrev());
                setIsNextButtonEnabled(emblaApi.canScrollNext());
            };
            onSelect();
            setScrollSnaps(emblaApi.scrollSnapList());
            emblaApi.on("select", onSelect);
        }
    }, [emblaApi]);

    return {
        emblaRef,
        scrollPrev,
        scrollNext,
        isPrevButtonEnabled,
        isNextButtonEnabled,
        scrollTo,
        selectedIndex,
        scrollSnaps,
    };
};
